import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Actions from '../../actions/actions';
import Animals from '../Helpers/Storage/Animals.json';
import Gender from '../Helpers/Storage/Gender.json';
import Castrated from '../Helpers/Storage/Castrated.json';
import Storage from '../Helpers/Storage/Storage';
import {
  Form,
  RadioValues,
  FormCardGroup,
  FormWrapper,
} from '../Helpers/Form';


const showPet = props => {
  const { petVm, authVm: { uid } } = props;
  const { action } = props.match.params;
  const {
    name, gender, species, castrated, description, image, id, userId
  } = petVm;

  return (
    <div className="addPet">
      <h1>{name}</h1>
      <Form onChange={() => { /* bubble */ }} >
        <FormWrapper name="image" text="Profilbild" type="image">
          {(image || species) && <div className="image"><img alt={name} src={image || (Storage.has(species) && Storage.get(species))} /></div>}
        </FormWrapper>
        {species && (
          <FormCardGroup text="Tierart">
            <RadioValues readOnly selectedValue={species} possibleValues={Animals} name="species" />
          </FormCardGroup>)}
        {gender && (
          <FormCardGroup text="Geschlecht">
            <RadioValues readOnly selectedValue={gender} possibleValues={Gender} name="gender" />
          </FormCardGroup>)}
        {castrated && (
          <FormCardGroup text="Kastriert / Unterbunden">
            <RadioValues readOnly selectedValue={castrated} possibleValues={Castrated} name="castrated" />
          </FormCardGroup>)}
        {description && <p>{description}</p>}

        {action === 'show' && uid === userId && <Link to={`/pet/edit/${id}`} alt="Edit" >Bearbeiten</Link>}
      </Form>
    </div>
  );
};

export default connect(
  state => ({ ...state.petReducer, ...state.authReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(showPet);



// WEBPACK FOOTER //
// ./src/pages/Pet/ShowPet.js